// extracted by mini-css-extract-plugin
export default {"head":"collection_head__7HNQ7","title":"collection_title__A8csb","feedWrapper":"collection_feedWrapper__VASnR","feed":"collection_feed__00qn6"};